import React from "react";
import { Route, useRouteMatch } from "react-router-dom";
import CreateEditCreditReportActiveUserThresholding from "./CreateEditCreditReportActiveUserThresholding";
import CreditReportActiveUserThresholdingList from "./CreditReportActiveUserThresholdingList";

const CreditReportFeaturePage = () => {
    let { path } = useRouteMatch();

    return (
        <div>
            <Route path={`${path}/thresholding`} exact={true}>
                <CreditReportActiveUserThresholdingList></CreditReportActiveUserThresholdingList>
            </Route>
            <Route path={`${path}/thresholding/:maxActiveCreditUsers/edit`} exact={true}>
                <CreateEditCreditReportActiveUserThresholding></CreateEditCreditReportActiveUserThresholding>
            </Route>
            <Route path={`${path}/thresholding/create`}>
                <CreateEditCreditReportActiveUserThresholding></CreateEditCreditReportActiveUserThresholding>
            </Route>
        </div>
    );
};

export default CreditReportFeaturePage;
